


import React from 'react'
import { Container, Col, Row, Image } from 'react-bootstrap'
import AboutSideBar from './AboutSideBar'
import PageTitle from '../../component/PageTitle'
import { Helmet } from "react-helmet";
const WhoWeWork = () => {
    return (
        <>
            <Helmet>
                <html lang="en" />
                <title>Muskaan - Who We Work With</title>
                <meta name="twitter:title" content='Polices' />
                <meta name="description" content="muskaan ngo" />
                <meta name="theme-color" content="#E6E6FA" />
            </Helmet>

            {/* <PageTitle pageTitle="Who We Work With" /> */}
            <div className='bgpettern pb-5 page-margin page-heigh'>
                <Container className='pt-4'>
                    <h4>Who We Work With</h4>
                    <p>Home  / Who We Work With</p>
                    <Row className='with_aside-border history'>
                        <Col sm={10}>
                            <div className='pt-3'>
                                <h5>Denotified &amp; Tribal Communities</h5>
                                <p>Denotified tribal communities are nomadic communities engaging in a range of practices that
                                    include bird/animal trapping, and pastoral activities, amongst others. Members of the
                                    denotified communities were notified as criminals at birth because they hereditarily
                                    participated in professions that were considered to be “criminal.” The law enacted resulted in
                                    systematic violence and discrimination towards members of these communities. Following
                                    independence, the Criminal Tribes Act was repealed and replaced by The Habitual Offenders
                                    Act 1952, which decriminalized/de-notified these communities. However, the imprint of the
                                    Criminal Tribes Act remains present today, with members of these communities continuing
                                    to face systematic violence and oppression.</p>




                                <p >De-notified tribal communities have been forced to adapt ‘settled’ way of living, pushed
                                    away from forest and resources of forests and poorly rehabilitated. Currently they either
                                    reside in their villages and earn through agricultural labour or have settled in bastis of cities
                                    with almost no realization of welfare mechanisms that can ensure upward socio-economic
                                    mobility. They are subjected to discrimination in their everyday lives and are often faced with
                                    institutional violence by being implicated in false cases. Several DNT communities report
                                    cases of police brutality and custodial killings.</p>



                                <Row>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-1.jpg')} alt="" className='w-100' />
                                    </Col>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-2.jpg')} alt="" className='w-100' />
                                    </Col>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-5.jpg')} alt="" className='w-100' />
                                    </Col>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-7.jpg')} alt="" className='w-100' />
                                    </Col>
                                </Row>

                                <p className='pt-4'>Members of denotified tribal communities continue to be ignored with no census being
                                    conducted or specific schemes being instituted to work towards correcting the social injustice
                                    that has been inflicted. They are denied proper education and livelihood opportunities. And
                                    there is sparse literature available in academic spaces on the lives, culture, and experiences of
                                    DNT communities.</p>
                                <p>At Muskaan, we have been working with people from DNT communities since the last two
                                    decades. Initially, when we understood that hardly any child from the community is being
                                    able to pursue higher secondary education because of a range of issues that arise from
                                    prevailing stigma and biases associated with the community. We started our interventions in
                                    the bastis of the Pardhi community (one of the DNTs).</p>





                                <p>Alongside working on the lines of ensuring that children in Pardhi community can continue
                                    their education, we realized that there are several reasons for the very frequent drop-outs of
                                    children. The community survives amidst the severe realities at their home (institutional
                                    violence, discrimination at school, workplace, lack of livelihood opportunities, etc.) that
                                    pushes children to go and collect scrap so that they too can contribute in providing for the
                                    family.</p>
                                <p>The culmination of these reasons creates an environment of trauma in the ecosystem of the
                                    gated bastis of the community. Subsequently the mental health too, takes a toll and the
                                    suicidal tendencies are often noticeable. Upon realizing these severities, Muskaan also began
                                    developing interventions focusing on these aspects because education in hindsight of these
                                    difficult realities limits any holistic socio-economic mobility of the community.</p>
                                <p>Since we started our school Jeevan Shiksha Pahal - a basti of Pardhi community where not a
                                    single child was able to pursue higher secondary education, has now a group of children who
                                    are on the verge of finishing their higher secondary education. This group is now determined
                                    and capable of leading fulfilling lives.</p>

                                <Row>

                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-6.jpg')} alt="" className='w-100' />
                                    </Col>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-3.jpg')} alt="" className='w-100' />
                                    </Col>
                                    <Col sm={3}>
                                        <Image src={require('../../assets/images/whowe/whowe-4.jpg')} alt="" className='w-100' />
                                    </Col>
                                </Row>

                                <p className='pt-4'>Some youngsters from this group have formed an organisation called Majal that works
                                    around the issues of their community by persisting internally addressing orthodox, patriarchal
                                    processes and challenging norms of local tribal councils, issues prevailing because of external
                                    agents like institutional biases, social discrimination, etc. Alongside this, interventions
                                    around child protection, creating opportunities focusing on alternative pedagogy of learning
                                    such as theater, sport (Ultimate Frisbee) music, barefoot basti counselors (that acknowledges
                                    the trauma of the people in their basti and supports the individuals), creating income-
                                    generating opportunities, etc. are some of the interventions that Muskaan works on alongside
                                    the Pardhi community.</p>

                                <p>Realizing the presence and the vulnerability of other DNTs that live in and around Bhopal as
                                    well as in Madhya Pradesh, we have started engaging with DNT communities like Kanjar,
                                    Bachhda, Bediya, Dafale, etc. in limited capacity. We are determined to expand our
                                    interventions and engage with vulnerable DNT communities and form a network of youth
                                    from these communities that comes together to challenge the biases and the stigma that De-
                                    notified tribes are collectively struggling with. The aim is to ensure the identity of belonging
                                    to a DNT community avails dignity and not the everyday struggle for their survival.</p>
                            </div>


                        </Col>

                        {/* <Col sm={3} className='pt-3'>
                            
                            <Image src={require('../../assets/images/whowe/whowe-2.jpg')} alt="" className='w-100' />
                            <Image src={require('../../assets/images/whowe/whowe-3.jpg')} alt="" className='w-100' />
                            <Image src={require('../../assets/images/whowe/whowe-4.jpg')} alt="" className='w-100' />                         
                      
                        </Col> */}

                        <Col sm={2} className='with_aside-border-left pt-3 '>
                            <h4>About Us</h4>
                            <AboutSideBar />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default WhoWeWork